module.exports = __webpack_public_path__ + "media/images/lb/071-484eb6aef42ea1071f0cb353567e603b.svg";